import React from 'react'
import './Home.css'
import resume from "../assets/corey-resume.pdf";
import DownloadButton from "./DownloadButton";
// import SimpleForm from './chatbot/SimpleForm'

function Home() {
    return (
        <div className="container">
            <div>
                <h1 style={{
                    color: "#21d14a",
                    fontSize: "36px",
                    display: "flex",
                    justifyContent: "center",
                }}
                >ccalhoun:$
                    <span className="blinking-cursor"
                    > |
                    </span>

                </h1>
                <h3 style={{
                    color: "whitesmoke",
                    fontSize: "26px",
                    display: "flex",
                    justifyContent: "center",
                }}>
                    Find me online:
                </h3>
                <ul>
                    <li style={{ cursor: "pointer" }}>
                        <a href="https://www.linkedin.com/in/corey-calhoun573/" target="_blank" rel="noreferrer"
                        >LinkedIn</a
                        >
                    </li>
                    <li style={{ cursor: "pointer" }}>
                        <a href="https://www.instagram.com/chilltrashpanda/" target="_blank" rel="noreferrer"
                        >Instagram</a
                        >
                    </li>
                    <li style={{ cursor: "pointer" }}>
                        <a href="https://github.com/corey-calhoun" target="_blank" rel="noreferrer">Github</a>
                    </li>
                    {/* <li style={{cursor: "pointer", color: "teal"}}>
                    <a href="#" target="_blank" rel="noreferrer"
                    >Download Resume</a
                    >
                </li> */}
                </ul>
            </div>
            <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                    marginTop: '20px',
            }}>
                <DownloadButton />
            </div>
        </div>

    )
}

export default Home
